/**
 * Environment configuration for AWS Development (Elastic Beanstalk)
 *
 * Usage:
 *   ng serve --configuration=develop
 *   ng build --configuration=develop
 */
export const environment = {
  production: false,
  apiUrl: 'https://api-dev.apibinnacle.org/api/v1',
  pusherKey: '1a0ac9155f3a28d18f4b',
  pusherCluster: 'us2',
};
